const LoadingIndicator: React.FC = () => {
  return (
    <div className="d-flex justify-content-center m-3">
      <div
        className="spinner-grow text-primary d-flex align-items-center"
        role="status"
      >
        <span className="visually-hidden">Loading...</span>
      </div>
      <div className="spinner-grow text-secondary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <div className="spinner-grow text-success" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default LoadingIndicator;
